import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import Router from './router/index'
import { Provider } from 'react-redux'
import store from './store'
import './common/iconfont.css'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <Router />
  </Provider>
)
